(function() {
  'use strict';

  angular.module('swapick')

  .filter('momentDateFormat', function(){
    return function(input, format){
        var m = moment(input, "YYYY-MM-DD");
        return m.format(format);
    }
  })

  .filter('momentDateTimeFormat', function(){
    return function(input, format){
        var m = moment(input, "YYYY-MM-DD HH:mm:ss");
        return m.format(format);
    }
  })

  //#todo  : not used right now
  .filter('apiImageFilter', function(){
    return function(input){
        if (input.indexOf('http') == 0){
          return input
        }
        return `/api/${input}`
    }
  });

})();


// WEBPACK FOOTER //
// ./src/filters/swapick-filters.js